<tds-header>

  <tds-header-title>
    @if(environment) {
      UPSprint
    } @else {
      @if(environmentName === 'ACP') {
        UPSprint - ACP
      } @else {
        UPSprint - DEV
      }
    }
  </tds-header-title>

  <tds-header-brand-symbol slot="end">
    <a routerLink="/" aria-label="Scania - red gryphon on blue shield"></a>
  </tds-header-brand-symbol>

</tds-header>
